import { path, createCachedSelector, defaultKeySelector } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { NetworkStatus } from '@cbridge-utils/network';
import { nodeStoreSelector } from '@cbridge-packages/node';
import { nodeAsStreamsNavigationItem } from '../_helpers/nodeAsStreamsNavigationItem';

export const streamsNodesSubNavigationPropsSelector = createCachedSelector(
  [
    path(nodeStoreSelector).list(),
    path(nodeStoreSelector).networkStatus(),
  ],
  (nodeList, networkStatus) => {
    return {
      items: nodeList.map(nodeAsStreamsNavigationItem),
      isLoading: networkStatus !== NetworkStatus.Done && networkStatus !== NetworkStatus.Failed,
    };
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
